var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.longName}},[_vm._v("\n    INSP-"+_vm._s(_vm._f("moment")(_vm.inspection.InspectionDate,"YYYY-MM-DD"))+"-JOB#"+_vm._s(_vm.inspection.JobsiteNumber)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }